import { render, staticRenderFns } from "./GrievanceDetails.vue?vue&type=template&id=2f7588fa&"
import script from "./GrievanceDetails.vue?vue&type=script&lang=js&"
export * from "./GrievanceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports